/**
 * True if this build is allowed to enter browser test mode (?test=true).
 * Keep unset/false on the production site that serves real users; set true only on
 * staging/local builds so testnet can be toggled without new deploys.
 */
function isTestModeBuildEnabled() {
  const allowTestnet = String(
    process.env.REACT_APP_ALLOW_TESTNET || process.env.REACT_APP_ENABLE_TEST_MODE || ''
  ).toLowerCase();
  return allowTestnet === '1' || allowTestnet === 'true' || allowTestnet === 'yes';
}

export function isTestMode() {
  // CRITICAL: Production must never use test mode - prevents test/main mix-up
  if (!isTestModeBuildEnabled()) return false;
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const v = (params.get('test') || '').toLowerCase();
  return v === '1' || v === 'true' || v === 'yes';
}

export function getAppChainConfig() {
  const test = isTestMode();

  // Mainnet defaults (Base)
  const main = {
    chainId: Number(process.env.REACT_APP_CHAIN_ID || '8453'),
    rpcUrl: process.env.REACT_APP_RPC_URL || 'https://mainnet.base.org',
    chainName: process.env.REACT_APP_CHAIN_NAME || 'Base',
    explorerUrl: process.env.REACT_APP_BLOCK_EXPLORER_URL || 'https://basescan.org',
    nativeSymbol: process.env.REACT_APP_NATIVE_SYMBOL || 'ETH',
    nativeName: process.env.REACT_APP_NATIVE_NAME || 'Ether',
    contractAddress: (process.env.REACT_APP_CONTRACT_ADDRESS || '').trim(),
  };

  // Testnet defaults (Base Sepolia)
  const testnet = {
    chainId: Number(process.env.REACT_APP_CHAIN_ID_TEST || '84532'),
    rpcUrl: process.env.REACT_APP_RPC_URL_TEST || 'https://sepolia.base.org',
    chainName: process.env.REACT_APP_CHAIN_NAME_TEST || 'Base Sepolia',
    explorerUrl: process.env.REACT_APP_BLOCK_EXPLORER_URL_TEST || 'https://sepolia.basescan.org',
    nativeSymbol: process.env.REACT_APP_NATIVE_SYMBOL_TEST || main.nativeSymbol,
    nativeName: process.env.REACT_APP_NATIVE_NAME_TEST || main.nativeName,
    contractAddress: (process.env.REACT_APP_CONTRACT_ADDRESS_TEST || '').trim(),
  };

  const cfg = test ? testnet : main;

  // Guardrails: prevent accidental mixing of prod/test settings.
  const isMainnetLike = cfg.chainId === 8453;
  const isTestnetLike = cfg.chainId === 84532;
  if (test && isMainnetLike) {
    throw new Error('Misconfiguration: test mode is enabled but chainId is mainnet (8453).');
  }
  if (!test && isTestnetLike) {
    throw new Error('Misconfiguration: main mode is enabled but chainId is testnet (84532).');
  }

  return cfg;
}

